import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/version"

const courseVersion = {
  courseVersionListPage(pageSize, limit, keyWord, subjectId) {
    return axios.get(pre + `/courseVersionListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
        }
    });
  },

  courseVersionList(subjectId) {
    return axios.get(pre + `/courseVersionList`, {
      params:
        {
          subjectId: subjectId,
        }
    });
  },
  courseVersionInfo(id) {
    return axios.get(pre + `/courseVersionInfo`, {params: {id: id}});
  },
  courseVersionSave(params) {
    return axios.post(pre + `/courseVersionSave`, qs.stringify(params));
  },
  courseVersionDelete(id) {
    return axios.delete(pre + `/courseVersionDelete`, {params: {id: id}});
  },
}
export default courseVersion;



// WEBPACK FOOTER //
// ./src/api/course/courseVersion.js